import React from "react";
import { View, ActivityIndicator } from "react-native";

type LoadingViewProps = {
  backgroundColor?: string;
};

export default function LoadingView({
  backgroundColor = "#ffffff",
}: LoadingViewProps) {
  return (
    <View
      className={`flex-1 justify-center items-center bg-[${backgroundColor}]`}
    >
      <ActivityIndicator size="large" color="#6b7280" />
    </View>
  );
}
